import { useQuery } from "@tanstack/react-query";
import { api } from "./config";

export const usePsySessionNote = (sessionId: number | undefined, category: "psychology" | "client_owner", enabled: boolean) => {
	const query = useQuery({
		queryKey: ["psy-session-note", sessionId, category],
		queryFn: () => getSessionNoteId(sessionId, category),
		enabled: enabled && !!sessionId,
		staleTime: 1000 * 30,
	});
	return query;
};

const getSessionNoteId = async (sessionId: number | undefined, category: string) => {
	const filter = { sessions: { _eq: sessionId }, category: { _eq: category } };
	const { data } = await api({
		method: "GET",
		url: "/items/notes",
		params: {
			fields: "id",
			filter: JSON.stringify(filter),
			limit: 1,
		},
	});
	const existingNoteId = data?.data?.[0]?.id ?? null;
	return existingNoteId;
};
